import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-inactivate-volunteer-modal',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './inactivate-volunteer-modal.component.html',
  styleUrls: ['./inactivate-volunteer-modal.component.scss'],
})
export class InactivateVolunteerModalComponent {
  @Input() targetId?: string;
  @Input() targetFolio: string = '';
  @Input() targetName: string = '';
  @Input() targetRole: 'student' | 'volunteer' = 'student';

  @Output() confirmed = new EventEmitter<{ comments: string }>();
  @Output() cancelled = new EventEmitter<void>();

  typedFolio: string = '';
  comments: string = '';
  isSubmitting: boolean = false;
  errorMessage: string | null = null;

  get isFolioValid(): boolean {
    return (this.typedFolio || '').trim().toUpperCase() === (this.targetFolio || '').trim().toUpperCase();
  }

  get isCommentsValid(): boolean {
    return (this.comments || '').trim().length > 0;
  }

  get canConfirm(): boolean {
    return this.isFolioValid && this.isCommentsValid && !this.isSubmitting;
  }

  onConfirm(): void {
    if (!this.canConfirm) return;
    this.isSubmitting = true;
    this.confirmed.emit({
      comments: this.comments.trim(),
    });
  }

  onCancel(): void {
    if (this.isSubmitting) return;
    this.cancelled.emit();
  }
}
